import {create} from 'zustand'

export default create( (set)=>{
    return {
                teleportTriggered: false,

                setTeleportTriggered: ()=>{
                    set(()=>{
                        return {teleportTriggered: true}
                    })
                },

                showWelcome: false,

                setWelcome: ()=>{
                    set(()=>{
                        return { showWelcome: true}
                    })
                },

                showEscape: false,

                setEscape: ()=>{
                    set(()=>{
                        return { showEscape: true}
                    })
                },

                showCountdown: false,

                setCountdown: ()=>{
                    set(()=>{
                        return {showCountdown: true}
                    })
                },

                fadeout: false,

                setFadeout: ()=>{
                    set(()=>{
                        return {fadeout: true}
                    })
                },

                portalEntered: false,

                setPortalEntered: ()=>{
                    set(()=>{
                        return {portalEntered: true}
                    })
                },

                countdownEnded: false,

                setCountdownEnded: ()=>{
                    set(()=>{
                        return {countdownEnded: true}
                    })
                },

                restart: false,

                setRestart: ()=>{
                    set(()=>{
                        return {restart: true}
                    })
                }

    }
} )
